import { ROLE } from "@/constants/privileges";
import taskService from "@/services/task";

const system = {
  namespaced: true,
  state: {
    changeRole: false,
    sideBarOpen: false,
    showNoteBar: false,
    savedQuery: {},
    taskCount: null,
  },
  getters: {
    changeRole: (state) => state.changeRole,
    sideBarOpen: (state) => state.sideBarOpen,
    showNoteBar: (state, getters, rootState, rootGetters) => {
      const show = state.showNoteBar;
      const activeId = rootGetters["user/active_role"];
      const canEdit = [ROLE.board, ROLE.developer].includes(activeId.id);
      if (canEdit) {
        return canEdit;
      }
      return show;
    },
    savedQuery: (state) => state.savedQuery,
    taskCount: (state) => state.taskCount,
  },
  mutations: {
    setChangeRole(state, value) {
      state.changeRole = value;
    },
    setSideBarOpen(state, value) {
      state.sideBarOpen = value;
    },
    setShowNoteBar(state, value) {
      state.showNoteBar = value;
    },
    setSavedQuery(state, query) {
      state.savedQuery = query;
    },
    setTaskCount(state, taskCount) {
      state.taskCount = taskCount;
    },
  },
  actions: {
    async getTaskCount({ commit }) {
      try {
        const { count } = await taskService.getTaskCount();
        commit("setTaskCount", count);
        return Promise.resolve(count);
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export default system;
